import styled from 'styled-components';
import { brandColors, commonColors } from 'styles/colors';
import { breakpoint, font } from 'styles/globals';
import { Theme, getColor } from 'styles/theme';

export const LoaderWrapper = styled.div`
  position: relative;
  height: 256px;
  .loader {
    margin: auto;
    position: absolute;
    left: 46%;
    top: 40%;
    svg {
      height: 38px;
    }
  }
`;

export const ProfileSummaryContainer = styled.div<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  font-weight: 600;
  color: ${getColor('textPrimary')};
  margin: 24px 16px 0;
  box-shadow: 4px 4px 20px 0px ${getColor('surfaceBlack')}0D;
  padding: 16px 0 0;
  font-size: 16px;
  line-height: 150%;

  &.my-account-mobile {
    margin-left: -16px; // To overflow the parent container
    margin-right: -16px; // To overflow the parent container
  }

  @media (${breakpoint.mdMin}) {
    margin: 24px 0;
    padding: 16px 0 0;
  }

  .modal-wrapper {
    button {
      padding: 8px 16px;
      font-family: ${font.graphikCond};
      font-size: 14px;
      font-weight: 600;
      line-height: 21px;
      letter-spacing: 0.5px;
    }

    @media (${breakpoint.mdMin}) {
      button {
        padding: 16px 32px;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  .subscription-btn-wrapper {
    padding: 16px;
    background: ${brandColors.crypto.shadeBrandPrimary100};

    button {
      color: ${getColor('textAccentSecondary')};
    }
  }
`;

export const TopLabelsContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  padding: 0 16px 8px;
`;

export const PianoResource = styled.div<{ theme: Theme }>`
  flex: 1;
  color: ${getColor('textAccentSecondary')};;
  text-transform: uppercase;

  @media (${breakpoint.lgMin}) {
    flex: none;
    margin-right: 16px;
  }
`;

export const SubscriptionStatus = styled.div<{ theme: Theme }>`
  text-transform: capitalize;
  font-size: 14px;
  padding: 4px 16px;
  color: ${getColor('textPrimary')};
  &.active {
    background: ${brandColors.own.shadeBrandPrimary200};
  }
  
  &.expiring {
    background: ${commonColors.shadeSemanticWarning200};
  }
  
  &.expiring.soon, &.cancelled {
    background: ${commonColors.shadeAccentPrimary200};
  }

  &.expired {
    background: ${commonColors.shadeAccentPrimary500};
  }

  &.inactive {
    background-color: ${getColor('surfaceSecondary')};
  }
`;

export const RenewLink = styled.a<{ theme: Theme }>`
  font-weight: 400;
  color: ${getColor('textLink')};
  text-decoration: none;
  padding: 8px;
  margin-left: 8px;

  svg {
    margin-bottom: -4px;
    width: 20px;
    height: 20px;
    fill: ${getColor('textLink')};
  }
`;

export const UserCardTitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 32px;
  text-transform: uppercase;
  padding-left: 8px;
  padding: 0 16px 0 8px;
  margin-left: 16px;
  border-left: 4px solid ${brandColors.crypto.brandPrimary};
`;

export const CurrentSubscriptionsContainer = styled.div<{ theme: Theme }>`
  font-weight: 400;
  color: ${getColor('neutralDarkGray')};
  padding: 24px 16px;

  p {
    font-size: 16px;
    font-weight: 600;
    color: ${getColor('textPrimary')};
  }
`;
